import React, { useMemo } from 'react';
import InitiateRFQContent from 'components/rfq/initiate-rfq/rfq-initiation';
import RFQInitiationPageStore, { PageStoreContext } from 'store/pages/rfq/initiate-rfq/rfq-initiation/pageStore';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';

const InitiateLevelFundedPage = (): JSX.Element => {
  const pageStore = useMemo(() => new RFQInitiationPageStore(), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <InitiateRFQContent
          title={RFQ_PROPOSAL_CARD_DATA.INITIATE_LEVEL_FUNDED.title}
          text={RFQ_PROPOSAL_CARD_DATA.INITIATE_LEVEL_FUNDED.text}
          showResponseDueDate
        />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default InitiateLevelFundedPage;
